import {createAction, createReducer} from 'redux-act';
import {combineReducers} from 'redux';
import {AxiosPromise} from 'axios';
import {FULFILLED, PENDING, REJECTED} from 'redux-promise-middleware';

import {StatusType} from 'constants/flow/flowTypes';
import {API_URL} from 'constants/api';
import {ENDPOINTS} from 'constants/endpoints';
import {instanceGusaBackend} from 'libs/api';

export type MyFitFiltersType = {frame_size: number[]; gender: number[]};

export type FiltersStateType = MyFitFiltersType & {
    status: StatusType;
};

export const TOGGLE_MY_FIT_STATE = 'TOGGLE_MY_FIT_STATE';
export const FETCH_MY_FIT = 'FETCH_MY_FIT';
export const SET_MY_FIT_STATE = 'SET_MY_FIT_STATE';
export const SCROLL_CTP_AFTER_MY_FIT = 'SCROLL_CTP_AFTER_MY_FIT';

export const initialFiltersState: FiltersStateType = {
    frame_size: [],
    gender: [],
    status: null,
};

export const toggleMyFitState = createAction(TOGGLE_MY_FIT_STATE);
export const setMyFitState = createAction<boolean>(SET_MY_FIT_STATE);
export const fetchMyFit = createAction<AxiosPromise>('FETCH_MY_FIT', () =>
    instanceGusaBackend({method: 'get', baseURL: API_URL, url: ENDPOINTS.CUSTOMER_MY_FIT}),
);
export const scrollCTPafterMyFit = createAction(SCROLL_CTP_AFTER_MY_FIT);
export const applyMyFitOnCategory = createAction('APPLY_MY_FIT_ON_CATEGORY');

export const isEnabled = createReducer<boolean>(
    {
        [`${toggleMyFitState}`]: state => !state,
        [`${setMyFitState}`]: (_, payload) => payload,
    },
    true,
);

export const filters = createReducer<FiltersStateType>(
    {
        [`${fetchMyFit}_${FULFILLED}`]: (
            _,
            {
                data: {
                    // eslint-disable-next-line @typescript-eslint/naming-convention
                    filters: {frame_size, gender},
                },
            },
        ) => ({
            // TODO: GUSA-10320 remove it after backend stops send duplicated ids
            frame_size: [...(new Set(frame_size) as any)],
            gender,
            status: 'fulfilled',
        }),
        [`${fetchMyFit}_${PENDING}`]: state => ({
            ...state,
            status: 'pending',
        }),
        [`${fetchMyFit}_${REJECTED}`]: state => ({
            ...state,
            status: 'rejected',
        }),
    },
    initialFiltersState,
);

export const myFit = combineReducers({isEnabled, filters});
